// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"741":"f3365c7204367b32","888":"a2ee2abbd3944ea5"}[chunkId] + ".css";
};